import React from 'react';
import PropTypes from 'prop-types';
import ConnectedDataForm from './ConnectedDataForm';

// TODO: Move to react-viewerbase

function DataRouting({ match }) {
  // TODO: Figure out which filters we want to pass in via a URL
  //const { patientId } = match.params;

  return <ConnectedDataForm />;
}

DataRouting.propTypes = {
  match: PropTypes.shape({
    params: PropTypes.shape({
      patientIds: PropTypes.string,
    }),
  }),
};

export default DataRouting;
